export default "__VITE_ASSET__5ae32582__"